import { useHistory } from "react-router-dom"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Applications from "../applications"
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { showEnvAuditNavigation } from "../../../store/actions";

const initialServices = [
  { name: "Request for ToRs", key: "request_for_tor_applications", count: 0 },
  { name: "Drafted ToRs", key: "drafted_to_r", count: 0 },
  { name: "Waiting EA Report", key: "waiting_report", count: 0 },
  { name: "Report for Review", key: "for_review", count: 0 },
  { name: "Drafted EA Certificate", key: "drafted_certificate", count: 0 },
  { name: "Approved Certificate", key: "approved", count: 0 },
  { name: "All Applications", key: "all_applications", count: 0 },
];


import EnvAuditService from "services/applications/envAudit/EnvAuditService"

const user = JSON.parse(localStorage.getItem("authUser"))

const appService = new EnvAuditService(user)

const TorApproved = (props) => {
  // const history = useHistory()
  const [mounted, setmounted] = useState(false)
  const [applications, setapplications] = useState()
  const [serviceName, setserviceName] = useState("")
  const [services, setServices] = useState(initialServices);
  const [serviceKey, setserviceKey] = useState("")
  const filter = new URLSearchParams(location.search).get('filter');

  useEffect(() => {
    if (props.showEnvAuditNav !== "SHOW_ENV_AUDIT_NAVIGATION") {
      props.showEnvAuditNavigation("SHOW_ENV_AUDIT_NAVIGATION");
    }
  }, [mounted]);

  useEffect(() => {
    // fetchStatistics()
    
    setServiceDetails()
    
  }, [filter])

  const setServiceDetails = () => {
    getToRApproved()
  }

  const fetchData = (serviceName, page=1) => {
   
  }

  const getToRApproved = (page=1) => {
    appService.getToRApprovedApplications(page).then(response => {
    //   console.log("tor approved --> ", response)
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }


  const paginate = page => {
    getToRApproved(page)
   }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>ToR Approved | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">ToR Approved</h6>
              </Col>
            </Row>
          </div>
          {/* <Row>
            {services.map((service, index) => (
              <Col md="4" sm="6" xs="12" key={service.name} className="mb-2">
                <Card
                  onClick={() => handleClick(service.name)}
                  className="shadow-sm cursor-pointer"
                >
                  <CardBody className="d-flex justify-content-between align-items-center">
                    <span className="font-weight-bold">{service.name}</span>
                    <span className="badge bg-primary text-white rounded-circle px-3 py-2">
                      {service.count}
                    </span>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row> */}

          {mounted ? (
            <Row>
              <Applications
                data={applications}
                user={user}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

TorApproved.propTypes = {
  showEnvAuditNavigation: PropTypes.func,
};

const mapStateToProps = (state) => ({
  showEnvAuditNav: state.Layout.show_env_audit_navigation,
});

export default withRouter(
  connect(mapStateToProps, { showEnvAuditNavigation })(TorApproved)
);